// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productListCard-CardLayout {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  border-radius: 16px;
  background: #fff;
  overflow: hidden;
  transition: box-shadow 0.15s, transform 0.12s;
  width: 100%;
  height: 100%;
  min-height: 248px;
  padding: 16px;
}

.productListCard-CardLayout:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.11);
  transform: translateY(-1px);
}

.productListCard-CardLayout.ccl-card-disabled {
  opacity: 0.6;
  pointer-events: none;
}

.productListCard-CardLayout.ccl-card-disabled:hover {
  box-shadow: none;
  transform: none;
}

/* ── Image ── */
.CardLayout-image-section {
  position: relative;
  height: 130px;
  width: 100%;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 16px;
}

.ccl-img-loader {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  z-index: 2;
}

/* Combo badge top-left of image */
.ccl-combo-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background: #f59e0b;
  padding: 2px 8px;
  border-radius: 6px;
  z-index: 1;
}

/* White pill overlay for OOS / not available */
.ccl-status-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.ccl-status-pill {
  background: rgba(255, 255, 255, 0.92);
  color: #374151;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 20px;
  text-align: center;
  max-width: 85%;
  line-height: 1.4;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
}

/* ── Title section ── */
.CardLayout-title-section {
  display: flex;
  flex: 1;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  padding: 10px 0 6px;
  min-height: 74px;
}

.CardLayout-title-logo-row-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  flex: 1 0 0;
  min-height: 100%;
}

.CardLayout-title-logo-row {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  justify-content: space-between;
}

.CardLayout-title {
  flex: 1;
  color: #1d293d;
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* Food type dot */
.ccl-food-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 3px;
}

.CardLayout-short-code {
  color: #9ca3af;
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}

/* "Includes X items" for combos */
.ccl-includes-text {
  font-size: 11px;
  font-weight: 600;
  color: #6366f1;
  margin: 0;
  line-height: 1;
}

/* ── Price + action row ── */
.CardLayout-mrp-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin-top: auto;
  padding-top: 4px;
  min-height: 42px;
}

.CardLayout-price {
  color: #1d293d;
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}

.CardLayout-variants {
  color: #0860e6;
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 130%;
}

/* Add + / View Combo button */
.ccl-action-btn {
  font-size: 13px;
  font-weight: 600;
  color: #0860e6;
  background: transparent;
  border: 1.5px solid #0860e6;
  border-radius: 20px;
  padding: 5px 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;
}

.ccl-action-btn:hover {
  background: #0860e6;
  color: #fff;
}

/* "Unavailable" text shown instead of button */
.ccl-unavailable-text {
  font-size: 13px;
  font-weight: 500;
  color: #9ca3af;
}

/* Dark mode — card applied via body.dark */
.dark .productListCard-CardLayout {
  background: #1e293b;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.dark .productListCard-CardLayout .CardLayout-title { color: #f1f5f9; }
.dark .productListCard-CardLayout .CardLayout-price { color: #93c5fd; }
.dark .productListCard-CardLayout .CardLayout-short-code { color: #64748b; }
.dark .productListCard-CardLayout .ccl-status-pill {
  background: rgba(30, 41, 59, 0.92);
  color: #cbd5e1;
}
.dark .productListCard-CardLayout .ccl-action-btn {
  color: #60a5fa;
  border-color: #3b82f6;
}
.dark .productListCard-CardLayout .ccl-action-btn:hover {
  background: #3b82f6;
  color: #fff;
}
.dark .productListCard-CardLayout .ccl-unavailable-text {
  color: #64748b;
}
.dark .productListCard-CardLayout .ccl-includes-text {
  color: #818cf8;
}

.ccl-food-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  margin-left: 6px;
}

@media (min-width: 1024px) and (max-width: 1100px) {
  .productListCard-CardLayout {
    min-height: 236px;
    padding: 12px;
    border-radius: 14px;
  }

  .CardLayout-image-section {
    height: 112px;
    border-radius: 12px;
  }

  .CardLayout-title-section {
    min-height: 66px;
    padding: 8px 0 4px;
  }

  .CardLayout-title-logo-row-container {
    gap: 3px;
  }

  .CardLayout-title {
    font-size: 14px;
    line-height: 1.25;
  }

  .CardLayout-short-code,
  .ccl-includes-text {
    font-size: 10px;
  }

  .CardLayout-mrp-section {
    min-height: 38px;
    gap: 4px;
  }

  .CardLayout-price {
    font-size: 14px;
  }

  .ccl-action-btn {
    font-size: 12px;
    padding: 5px 10px;
  }

  .ccl-unavailable-text {
    font-size: 12px;
  }

  .ccl-status-pill {
    font-size: 11px;
    padding: 6px 10px;
  }

  .ccl-food-icon {
    width: 14px;
    height: 14px;
    margin-left: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/CartCardViewLayout/CartCardViewLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,OAAO;EACP,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,sDAAsD,cAAc,EAAE;AACtE,sDAAsD,cAAc,EAAE;AACtE,2DAA2D,cAAc,EAAE;AAC3E;EACE,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":[".productListCard-CardLayout {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0;\n  border-radius: 16px;\n  background: #fff;\n  overflow: hidden;\n  transition: box-shadow 0.15s, transform 0.12s;\n  width: 100%;\n  height: 100%;\n  min-height: 248px;\n  padding: 16px;\n}\n\n.productListCard-CardLayout:hover {\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.11);\n  transform: translateY(-1px);\n}\n\n.productListCard-CardLayout.ccl-card-disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.productListCard-CardLayout.ccl-card-disabled:hover {\n  box-shadow: none;\n  transform: none;\n}\n\n/* ── Image ── */\n.CardLayout-image-section {\n  position: relative;\n  height: 130px;\n  width: 100%;\n  flex-shrink: 0;\n  overflow: hidden;\n  border-radius: 16px;\n}\n\n.ccl-img-loader {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.6);\n  z-index: 2;\n}\n\n/* Combo badge top-left of image */\n.ccl-combo-badge {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #fff;\n  background: #f59e0b;\n  padding: 2px 8px;\n  border-radius: 6px;\n  z-index: 1;\n}\n\n/* White pill overlay for OOS / not available */\n.ccl-status-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n}\n\n.ccl-status-pill {\n  background: rgba(255, 255, 255, 0.92);\n  color: #374151;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 6px 14px;\n  border-radius: 20px;\n  text-align: center;\n  max-width: 85%;\n  line-height: 1.4;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);\n}\n\n/* ── Title section ── */\n.CardLayout-title-section {\n  display: flex;\n  flex: 1;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n  padding: 10px 0 6px;\n  min-height: 74px;\n}\n\n.CardLayout-title-logo-row-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 4px;\n  width: 100%;\n  flex: 1 0 0;\n  min-height: 100%;\n}\n\n.CardLayout-title-logo-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n  justify-content: space-between;\n}\n\n.CardLayout-title {\n  flex: 1;\n  color: #1d293d;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.3;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n/* Food type dot */\n.ccl-food-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-top: 3px;\n}\n\n.CardLayout-short-code {\n  color: #9ca3af;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n/* \"Includes X items\" for combos */\n.ccl-includes-text {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6366f1;\n  margin: 0;\n  line-height: 1;\n}\n\n/* ── Price + action row ── */\n.CardLayout-mrp-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  margin-top: auto;\n  padding-top: 4px;\n  min-height: 42px;\n}\n\n.CardLayout-price {\n  color: #1d293d;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.CardLayout-variants {\n  color: #0860e6;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 130%;\n}\n\n/* Add + / View Combo button */\n.ccl-action-btn {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0860e6;\n  background: transparent;\n  border: 1.5px solid #0860e6;\n  border-radius: 20px;\n  padding: 5px 14px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s, color 0.15s;\n}\n\n.ccl-action-btn:hover {\n  background: #0860e6;\n  color: #fff;\n}\n\n/* \"Unavailable\" text shown instead of button */\n.ccl-unavailable-text {\n  font-size: 13px;\n  font-weight: 500;\n  color: #9ca3af;\n}\n\n/* Dark mode — card applied via body.dark */\n.dark .productListCard-CardLayout {\n  background: #1e293b;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.dark .productListCard-CardLayout .CardLayout-title { color: #f1f5f9; }\n.dark .productListCard-CardLayout .CardLayout-price { color: #93c5fd; }\n.dark .productListCard-CardLayout .CardLayout-short-code { color: #64748b; }\n.dark .productListCard-CardLayout .ccl-status-pill {\n  background: rgba(30, 41, 59, 0.92);\n  color: #cbd5e1;\n}\n.dark .productListCard-CardLayout .ccl-action-btn {\n  color: #60a5fa;\n  border-color: #3b82f6;\n}\n.dark .productListCard-CardLayout .ccl-action-btn:hover {\n  background: #3b82f6;\n  color: #fff;\n}\n.dark .productListCard-CardLayout .ccl-unavailable-text {\n  color: #64748b;\n}\n.dark .productListCard-CardLayout .ccl-includes-text {\n  color: #818cf8;\n}\n\n.ccl-food-icon {\n  width: 16px;\n  height: 16px;\n  object-fit: contain;\n  margin-left: 6px;\n}\n\n@media (min-width: 1024px) and (max-width: 1100px) {\n  .productListCard-CardLayout {\n    min-height: 236px;\n    padding: 12px;\n    border-radius: 14px;\n  }\n\n  .CardLayout-image-section {\n    height: 112px;\n    border-radius: 12px;\n  }\n\n  .CardLayout-title-section {\n    min-height: 66px;\n    padding: 8px 0 4px;\n  }\n\n  .CardLayout-title-logo-row-container {\n    gap: 3px;\n  }\n\n  .CardLayout-title {\n    font-size: 14px;\n    line-height: 1.25;\n  }\n\n  .CardLayout-short-code,\n  .ccl-includes-text {\n    font-size: 10px;\n  }\n\n  .CardLayout-mrp-section {\n    min-height: 38px;\n    gap: 4px;\n  }\n\n  .CardLayout-price {\n    font-size: 14px;\n  }\n\n  .ccl-action-btn {\n    font-size: 12px;\n    padding: 5px 10px;\n  }\n\n  .ccl-unavailable-text {\n    font-size: 12px;\n  }\n\n  .ccl-status-pill {\n    font-size: 11px;\n    padding: 6px 10px;\n  }\n\n  .ccl-food-icon {\n    width: 14px;\n    height: 14px;\n    margin-left: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
